<div class="error">
    <img src="assets/images/error.png" alt="error" srcset="">
    <h2>{{'ERROR.HEADER' | translate}}</h2>
    <p>{{'ERROR.TITLE' | translate}}</p>
</div>